import React, { useState } from "react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    { title: "Inicio", path: "/" },
    { title: "Servicios", path: "/services" },
    { title: "Herramientas", path: "/Herramientas" },
    { title: "Nosotros", path: "/nosotros" }
  ];

  return (
    <div className="relative z-50 w-full">
      <nav className="text-white shadow-lg bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900">
        <div className="container w-full px-4 mx-auto">
          <div className="flex items-center justify-between h-16">
            <a
              href="/"
              className="relative z-50 flex items-center flex-shrink-0 gap-2 ml-4 md:gap-3 md:ml-20"
            >
              {/* <img
                src="/logo512.png"
                alt="Romero & Asociados"
                className="object-contain h-9 w-9 md:h-11 md:w-11"
              /> */}
              <span className="text-xl font-bold text-transparent md:text-2xl bg-clip-text bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400">
                ROMERO & ASOCIADOS
              </span>
            </a>

            <div className="hidden mr-4 space-x-8 md:flex md:mr-20">
              {menuItems.map((item) => (
                <a
                  key={item.path}
                  href={item.path}
                  className="relative py-2 overflow-hidden text-gray-300 transition-colors duration-300 hover:text-white group"
                >
                  <span className="relative z-10">{item.title}</span>
                  <span className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></span>
                  <span className="absolute inset-0 transition-transform duration-300 transform scale-y-0 bg-gradient-to-r from-blue-500/10 via-purple-500/10 to-pink-500/10 group-hover:scale-y-100"></span>
                </a>
              ))}
            </div>

            <div className="relative z-50 mr-4 md:hidden">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="p-2 transition-colors duration-200 rounded-lg focus:outline-none group"
                aria-label="Menu"
              >
                <div className="relative w-6 h-6">
                  <span 
                    className={`absolute h-0.5 w-6 bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 transform transition-all duration-300 ease-in-out ${
                      isOpen ? 'rotate-45 translate-y-2.5' : 'translate-y-0'
                    }`}
                  ></span>
                  <span 
                    className={`absolute top-1/2 -translate-y-1/2 h-0.5 w-6 bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 transform transition-all duration-300 ease-in-out ${
                      isOpen ? 'opacity-0 translate-x-2' : 'opacity-100'
                    }`}
                  ></span>
                  <span 
                    className={`absolute h-0.5 w-6 bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 transform transition-all duration-300 ease-in-out ${
                      isOpen ? '-rotate-45 -translate-y-2.5' : 'translate-y-5'
                    }`}
                  ></span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </nav>

      <div 
        className={`fixed inset-0 w-full h-full bg-black/60 backdrop-blur-sm transform transition-all duration-300 ease-in-out md:hidden ${
          isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
        onClick={() => setIsOpen(false)}
      >
        <div 
          className="flex items-center justify-center w-full h-full"
          onClick={(e) => e.stopPropagation()}
        >
          <div className={`w-full max-w-md px-4 transform transition-all duration-500 ease-in-out ${
            isOpen ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
          }`}>
            <div className="grid w-full gap-4">
              {menuItems.map((item, index) => (
                <a
                  key={item.path}
                  href={item.path}
                  className={`w-full transform transition-all duration-300 delay-${index * 100} ${
                    isOpen ? 'translate-x-0 opacity-100' : 'translate-x-8 opacity-0'
                  }`}
                >
                  <div className="relative w-full overflow-hidden transition-colors duration-300 rounded-lg group bg-gray-800/50 hover:bg-gray-700/50">
                    <div className="absolute inset-0 transition-transform duration-300 transform scale-x-0 bg-gradient-to-r from-blue-500/10 via-purple-500/10 to-pink-500/10 group-hover:scale-x-100"></div>
                    <div className="relative w-full p-4 text-center">
                      <span className="text-lg font-medium text-gray-300 transition-colors duration-300 group-hover:text-white">
                        {item.title}
                      </span>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;